module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a03/main_sp_efc3a7d788bc51fd532a38c7ee4b71a4.jpg";